import React from "react";
import {Box,TextField, MenuItem} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {
platformSelected
} from "../../store/Store";

function PlatformFilter({data,label,fid}){
    const dispatch = useDispatch();
    const platform = useSelector((state)=>state.API.platformText);

    function selectOption(e){
        dispatch(platformSelected(e.target.value));
    }

	return (
		<Box className="specific_filter">
			<TextField value={platform}
                       select
                       label = {label}
                       variant="filled"
                       style={{width:"100%"}}
                       color="success"
                       size="small"
                       onChange={selectOption}
                       >
                {
                    data.map((item,index)=>{
                        return <MenuItem value={item} key={index}>{item}</MenuItem>
                    })
                }

            </TextField>
		</Box>
	);
}

export default PlatformFilter;